import { RootState } from '../models';

export const selectIsPlayerLoading = (state: RootState) => {
  return !state.data.isLoaded || state.video.isLoading;
};